function getFileExtension(filename) {
    return filename.split('.').pop();
  }
  
  export default getFileExtension